export default __webpack_public_path__ + "static/media/Resume.9a042eaa.pdf";